exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".first-login-pwd-dialog .el-dialog__body{padding-top:0.10667rem}", ""]);

// exports
